<h6 mat-dialog-title><span [innerHTML]="title" class="[ headline-small ][ on-surface ]"></span></h6>
@if (message) {
  <div mat-dialog-content>
    <p [class]="messageClass" data-cy="cm-content" [innerHTML]="message"></p>
  </div>
}
<div mat-dialog-actions class="[ cluster justify-end ]">
  <div>
    <dcr-inline-button
      campusClickStopPropagation
      [label]="helpLabel"
      [disabled]="disableHelp"
      data-cy="cm-confirm"
      (click)="confirm()"
    ></dcr-inline-button>

    <dcr-filled-button [label]="cancelLabel" data-cy="cm-cancel" (click)="cancel()"></dcr-filled-button>
  </div>
</div>
